import React, {useCallback} from 'react';

import {Group} from '@pb/kit-component-group';

import {CELLS} from './constants';
import {RangeCell} from './range-cell';

import type {CellType} from './constants';
import type {OnCellChange, ValueAcc} from './typedef';

type Props = {
    isSingleAddress?: boolean,
    rangesBusy: boolean,
    data: ValueAcc,
    onChange: OnCellChange,
    disabled?: boolean,
};
export const RangeField = (props: Props) => {
    const {isSingleAddress} = props;
    const getProps = useCallback((type: CellType) => {
        const {data, rangesBusy, onChange, disabled} = props;
        return {
            rangesBusy,
            ...data[type],
            type,
            onChange,
            disabled,
        };
    }, [props]);

    return (
        <Group gap="xs" alignItems="center">
            <RangeCell {...getProps(CELLS.START_A)}/>
            <RangeCell {...getProps(CELLS.START_B)}/>
            <RangeCell {...getProps(CELLS.START_C)}/>
            <RangeCell {...getProps(CELLS.START_D)}/>
            {!isSingleAddress ? (
                <Group gap="xs" alignItems="center">
                    <div>—</div>
                    <RangeCell {...getProps(CELLS.END_A)}/>
                    <RangeCell {...getProps(CELLS.END_B)}/>
                    <RangeCell {...getProps(CELLS.END_C)}/>
                    <RangeCell {...getProps(CELLS.END_D)}/>
                </Group>
            ) : null}
        </Group>
    );
};
